module.exports = __webpack_public_path__ + "img/picture2.e28ea2cb.jpg";